import { z } from 'zod';

/** Foto de hotel/quarto no wire — shape idêntico já usado pelo `hotel_planner`,
 *  pelo `hotel_rooms` e pelo detalhe do hotel. Levantado para cá para não haver
 *  uma terceira cópia inline. `url` fica sem `.min(1)` de propósito: afrouxar é
 *  seguro, apertar rejeitaria blocos já persistidos no histórico. */
export const HotelPhotoSchema = z.object({ url: z.string(), description: z.string().optional() });

/** A lista de fotos do fornecedor no shape do wire: sem URL vazia, descrição só
 *  quando diz algo, no máximo `max`, e `undefined` quando não sobra nenhuma — o
 *  card distingue "sem foto" de "lista vazia". */
export function hotelPhotosToChatUi(
  photos: readonly { url?: string; description?: string }[] | undefined,
  max: number,
): z.infer<typeof HotelPhotoSchema>[] | undefined {
  if (!photos?.length) return undefined;
  const mapped = photos
    .map((photo) => {
      const url = photo.url?.trim();
      const description = photo.description?.trim();
      return url ? { url, ...(description ? { description } : {}) } : undefined;
    })
    .filter((photo) => photo !== undefined)
    .slice(0, max);
  return mapped.length > 0 ? mapped : undefined;
}
